import ApiClient from "../client";
import { PaginatedResponse } from "../types";
import {
  ApiChallenge,
  ApiChallengeEntry,
  ApiChallengeEntryDetail,
  ApiChallengeEntryLog,
  ApiCreateChallengePayload,
  ApiUpdateChallengePayload,
} from "../types/challenges";

export const getChallenge = (client: ApiClient, challengeUuid: string) =>
  client.get<ApiChallenge>(`/challenges/${challengeUuid}`);

export const createChallenge = (
  client: ApiClient,
  payload: ApiCreateChallengePayload
) => client.post<ApiChallenge>("/challenges", payload);

export const updateChallenge = (
  client: ApiClient,
  challengeUuid: string,
  payload: ApiUpdateChallengePayload
) => client.patch<ApiChallenge>(`/challenges/${challengeUuid}`, payload);

export const deleteChallenge = (client: ApiClient, challengeUuid: string) =>
  client.delete(`/challenges/${challengeUuid}`);

export const getChallengeEntries = (client: ApiClient, challengeUuid: string) =>
  client.get<ApiChallengeEntry[]>(`/challenges/${challengeUuid}/entries`);

export const getChallengeEntry = (
  client: ApiClient,
  challengeUuid: string,
  entryUuid: string
) =>
  client.get<ApiChallengeEntryDetail>(
    `/challenges/${challengeUuid}/entries/${entryUuid}`
  );

export const getChallengeEntryLogs = (
  client: ApiClient,
  challengeUuid: string,
  entryUuid: string,
  searchParams?: URLSearchParams
) => {
  const url =
    `/challenges/${challengeUuid}/entries/${entryUuid}/logs` +
    (searchParams ? `?${searchParams.toString()}` : "");
  return client.get<PaginatedResponse<ApiChallengeEntryLog>>(url);
};

export const recordChallengeRedemption = (
  client: ApiClient,
  challengeUuid: string,
  entryUuid: string,
  rewardUuid: string
) => {
  return client.post(`/challenges/${challengeUuid}/redeem-reward`, {
    entry: entryUuid,
    reward: rewardUuid,
  });
};

export const deleteRewardRedemption = (
  client: ApiClient,
  challengeUuid: string,
  entryUuid: string,
  rewardUuid: string
) => {
  return client.delete(
    `/challenges/${challengeUuid}/entries/${entryUuid}/reward-redemptions/${rewardUuid}`
  );
};

export const manuallyVerifyChallengeEntryLog = (
  client: ApiClient,
  challengeUuid: string,
  entryUuid: string,
  logUuid: string
) => {
  return client.patch(
    `/challenges/${challengeUuid}/entries/${entryUuid}/logs/${logUuid}`,
    {
      value: 1,
    }
  );
};

export const removeChallengeEntryLog = (
  client: ApiClient,
  challengeUuid: string,
  entryUuid: string,
  logUuid: string
) => {
  return client.delete(
    `/challenges/${challengeUuid}/entries/${entryUuid}/logs/${logUuid}`
  );
};

export const endpoints = {
  getChallenge,
  createChallenge,
  updateChallenge,
  deleteChallenge,
  getChallengeEntries,
  getChallengeEntryLogs,
  getChallengeEntry,
  recordChallengeRedemption,
  deleteRewardRedemption,
  manuallyVerifyChallengeEntryLog,
  removeChallengeEntryLog,
};
